//import { faCheckCircle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import styles from 'components/UI/V3/ActivityLog/ActivityLogItem.module.scss';
import moment from 'moment';
import React from 'react';
import { ActivityLogItemStatus } from './types';
import { faCheck, faExclamation, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

interface ActivityLogItemProps {
    message: React.ReactNode;
    date: string | Date | moment.Moment;
    status: ActivityLogItemStatus;
    icon?: any;
    isLast?: boolean;
    className?: string;
    onClick?: () => void;
}

const getDefaultIcon = (status: ActivityLogItemStatus) => {
    switch (status) {
        case 'success':
            return faCheck;
        case 'error':
        case 'warning':
            return faExclamation;
        case 'canceled':
            return faXmark;
        default:
            return faCheck;
    }
};

export const ActivityLogItem: React.FC<ActivityLogItemProps> = ({
    message,
    date,
    status,
    icon,
    isLast = false,
    className,
    onClick
}) => {
    const displayIcon = icon || getDefaultIcon(status);

    const formatDate = (dateValue: string | Date | moment.Moment): string => {
        if (moment.isMoment(dateValue)) {
            return dateValue.format('MMM D, YYYY');
        }
        return moment(dateValue).format('MMM D, YYYY');
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onClick?.();
        }
    };

    return (
        <div
            className={clsx(styles.root, { [styles.clickable]: !!onClick }, className)}
            role={onClick ? 'button' : undefined}
            tabIndex={onClick ? 0 : undefined}
            onClick={onClick}
            onKeyDown={onClick ? handleKeyDown : undefined}
        >
            <div className={styles.iconColumn}>
                <div className={clsx(styles.icon, styles[`status${status.charAt(0).toUpperCase() + status.slice(1)}`])}>
                    <FontAwesomeIcon icon={displayIcon} />
                </div>
                {!isLast && <div className={styles.line} />}
            </div>
            <div className={styles.content}>
                <div className={styles.message}>{message}</div>
                <div className={styles.date}>{formatDate(date)}</div>
            </div>
            {onClick && (
                <FontAwesomeIcon
                    icon={faChevronRight}
                    className={styles.chevron}
                />
            )}
        </div>
    );
};
